import React from 'react';

const OtpModal = ({ show, handleClose, verifyOtp }) => {
  return (
    // alert(verifyOtp),
    <div className={`modal ${show ? 'd-block' : 'd-none'}`} style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Enter OTP Sent to Email</h5>
            <button type="button" className="close" onClick={handleClose}>
              &times;
            </button>
          </div>
          <div className="modal-body">
            <input type="text" id="otpInput" className="form-control" placeholder="Enter OTP " maxLength="6" />
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={() => verifyOtp(document.getElementById("otpInput").value)}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpModal;